import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'finalized', label: 'Finalized' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'period', label: 'Period' },
  { key: 'final_score', label: 'Final Score', align: 'right' },
  { key: 'status', label: 'Status' },
  { key: 'finalized_by', label: 'Finalized By' },
];

export function PerformanceRegisterReport() {
  return (
    <ReportView
      title="Performance Reviews Register"
      description="Every performance review with its computed final score and finalization status."
      endpoint="/reports/hr/performance"
      columns={COLUMNS}
      filters={['status']}
      statusOptions={STATUS_OPTIONS}
      listColumns={{ period: 'performance_review_period' }}
    />
  );
}
